// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"form-rich-input_inputContainer__hX0KI","richInputControls":"form-rich-input_richInputControls__pxFDP"};